// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
import router from './router'
import animated from 'animate.css'
import axios from 'axios'


Vue.use(animated);
Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.prototype.$axios = axios;
axios.defaults.baseURL = window.gurl.SERVICE_CONTEXT_PATH;
// console.info(axios.defaults.baseURL)



router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
});


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js